import React from 'react';
import Button from '@cpg-its/ads.common.button';
import { useDispatch, useSelector } from 'react-redux';
import { useCompensationSetting } from '../../../components/use-compensation-setting';
import { CompensationHistoryState, ScheduledPayment } from './compensation-history-model';
import { togglePre2018 } from './compensation-history-slice';
import { ScheduledPaymentView } from './scheduled-payment-view';
import { tabStyles } from '../../../../../global/constants/theme/styles/components/custom-tabs';
import { ContentSpacer } from '../../../../../global/components/layout/generic-content-spacer';
import { DividerSection } from '../../../../../global/components/layout/divider-section';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { useLockedPageState } from '../../../../../global/hooks/useLockedPageState';
import { LockedPageKeys } from '../../../../../global/models/locked-page-model';


const preScheduledPaymentKey = 'ScheduledPaymentsPre2018';
const postScheduledPaymentKey = 'ScheduledPaymentsPost2018';

export function ScheduledPayments() {
	const tabClasses = tabStyles();
	const dispatch = useDispatch();
	const settings = useCompensationSetting();
	let scheduledPayments: ScheduledPayment[];
	let paginationName;
	const compState = useSelector<TcsmStates, CompensationHistoryState>(state => state.compensationHistoryState);

	const lockedState = useLockedPageState(LockedPageKeys.Compensation);


	if (compState.pre2018) {
		scheduledPayments = compState.pre2018ScheduledPayments;
		paginationName = preScheduledPaymentKey;
	} else {
		scheduledPayments = compState.post2018ScheduledPayments;
		paginationName = postScheduledPaymentKey;
	}

	const page = useSelector<TcsmStates, number>(state => state.paginationState?.books[paginationName]?.currentPage);

	const toggle = () => {
		dispatch(togglePre2018(!compState.pre2018));
	};

	const ToggleButtons = () => {

		return (
			<ContentSpacer>
				<div className={tabClasses.tabsContainer}>
					<Button type='button' text={settings.pre2018} disabled={compState.pre2018} onClick={toggle} />

					<Button type='button' text={settings.post2018} disabled={!compState.pre2018} onClick={toggle} />

				</div>
			</ContentSpacer>
		);
	};

	if (!scheduledPayments || scheduledPayments.length === 0) {
		return (
			<DividerSection removeDivider sectionText={settings.scheduledPaymentTitle}>
				<ToggleButtons />
				<p>{settings.emptyScheduledPaymentMessage}</p>

			</DividerSection>
		);
	}


	return (
		<DividerSection removeDivider sectionText={settings.scheduledPaymentTitle}>
			<ToggleButtons />
			<ScheduledPaymentView
				editDisabled={lockedState.isLocked}
				current={scheduledPayments[page - 1]}
				next={page < scheduledPayments.length ? scheduledPayments[page] : null}
				paginationName={paginationName}
				totalPages={scheduledPayments.length} />

		</DividerSection>
	);
}